import { useCallback } from 'react';
import { useRequest } from '@Hooks';
import { API } from '@Services';
import { ProjectUpdate } from '@Types';

export interface ProjectUpdateInput {
  project_id: number;
  description: string;
  image?: string | null;
  project_update_image_ids?: number[];
  video_url?: string | null;
}

export const useCreateProjectUpdate = () => {
  const [fetch, response] = useRequest<ProjectUpdate>();

  const createProjectUpdate = useCallback(
    (data: ProjectUpdateInput) =>
      fetch(API.paths.all_project_updates, 'post', {
        data,
      }),
    [fetch],
  );

  return [createProjectUpdate, response] as const;
};
